import { useEffect } from "react";
import type { PredictionStatus } from "../../types";
import { getStaticAssetPath } from "../../util";

const statusFaviconMap: Record<PredictionStatus, string> = {
  processing: getStaticAssetPath("/static/favicons/running.png"),
  starting: getStaticAssetPath("/static/favicons/running.png"),
  canceled: getStaticAssetPath("/static/favicons/canceled.png"),
  failed: getStaticAssetPath("/static/favicons/failed.png"),
  succeeded: getStaticAssetPath("/static/favicons/succeeded.png"),
  canceling: getStaticAssetPath("/static/favicons/running.png"),
  aborted: getStaticAssetPath("/static/favicons/failed.png"),
};

export function PredictionStatusFavicon({
  status,
}: { status: PredictionStatus }) {
  useEffect(() => {
    const icoLink = document.getElementById("favicon-ico");
    const svgLink = document.getElementById("favicon-png");

    if (!icoLink || !svgLink) {
      return;
    }

    icoLink.setAttribute("href", statusFaviconMap[status]);
    svgLink.setAttribute("href", statusFaviconMap[status]);
  }, [status]);

  return null;
}
